module.exports="precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main () {\n    gl_FragColor = color;\n}\n";